import type { Product, WithContext, Book } from "schema-dts";

type StructureBookDataType = {
  priceInfo: {
    discountPrice?: string;
    regularPrice: string;
  };
  slugUrl: string;
  images: {
    src: string;
    type?: "product-cover";
  }[];
  productInfo: {
    title: string;
    author: string;
    ISBN: string;
  };
  description: {
    paragraphs: { text: string }[];
  };
};

export const bookStructuredData = (
  book: StructureBookDataType
): WithContext<Product | Book> => {
  const price = book.priceInfo.discountPrice
    ? book.priceInfo.discountPrice
    : book.priceInfo.regularPrice;
  const imageSrc =
    book.images.find((img) => {
      return img.type === "product-cover";
    })?.src || book.images[0].src;

  return {
    "@context": "https://schema.org",
    // @ts-expect-error this is ok for google ["Product", "Book"]
    "@type": ["Product", "Book"], // TODO: google does not recognize only Book type :(
    name: book.productInfo.title,
    image: new URL(imageSrc, "https://dystans.cc").toString(),
    description: book.description.paragraphs[0].text,
    isbn: book.productInfo.ISBN,
    publisher: {
      "@type": "Organization",
      name: "Wydawnictwo Dystans",
    },
    author: {
      "@type": "Person",
      givenName: book.productInfo.author.split(" ")[0],
      familyName: book.productInfo.author.split(" ").slice(1).join(" "),
    },
    offers: {
      "@type": "Offer",
      url: `https://dystans.cc/ksiazka/${book.slugUrl}`,
      priceCurrency: "PLN",
      price: parseFloat(price.replace(",", ".")).toFixed(2),
      itemCondition: "https://schema.org/NewCondition",
      availability: "https://schema.org/InStock",
    },
  };
};
